<template>
   <div class="change-details-c">
      <!-- <h1>Change Details</h1> -->
      <!-- Add your template content here -->
      <!-- {{ SortingItems }} -->

      <template v-for="(item, itemIndex) in items">
         <ChangeItem :key="itemIndex" :task="item" />
      </template>
   </div>
</template>
<script>
import { taskService } from "@/service/index.js";
import ChangeItem from "./ChangeItem.vue";

export default {
   name: "ChangeDetails",
   props: {
      taskIds: Array,
   },
   components: {
      ChangeItem,
   },
   data() {
      return {
         items: [],
      };
   },
   mounted() {
      this.taskIds.forEach((taskId) => {
         this.handlerConfirmation(taskId);
      });
   },

   methods: {
      compareSegments(oldSegments, newSegments) {
         const changes = [];

         oldSegments.forEach((oldSegment) => {
            const matchingNewSegment = newSegments.find((newSegment) => newSegment.flightIndex === oldSegment.flightIndex && newSegment.segmentIndex === oldSegment.segmentIndex);

            if (matchingNewSegment) {
               const segmentChanges = {};

               Object.keys(oldSegment).forEach((key) => {
                  if (oldSegment[key] !== matchingNewSegment[key]) {
                     segmentChanges[key] = {
                        old: oldSegment[key],
                        new: matchingNewSegment[key],
                     };
                  }
               });

               if (Object.keys(segmentChanges).length > 0) {
                  changes.push({
                     flightIndex: oldSegment.flightIndex,
                     segmentIndex: oldSegment.segmentIndex,
                     changes: segmentChanges,
                  });
               }
            }
         });

         return changes;
      },
      isValidDate(value) {
         const date = new Date(value);
         return !isNaN(date.getTime());
      },
      handlerConfirmation(taskId) {
         taskService
            .getFlightChangeConfirmationTask({ taskId })
            .then((res) => {
               // if (res.result.success && res.task.type == 11) {
               if (res.result.success) {
                  const changes = this.compareSegments(res.oldSegments, res.newSegments);

                  // Değişiklik mesajı oluştur
                  const createChangesMessage = (changes) => {
                     if (!changes.length) {
                        return "Hiçbir değişiklik yapılmadı.";
                     }

                     return changes
                        .map((change) => {
                           const segmentInfo = `<h2>${change.flightIndex}.${this.$i18n.t("common_flight")}, ${change.segmentIndex}.${this.$i18n.t("common_segment")}</h2>`;
                           const details = Object.keys(change.changes)
                              .map((key) => {
                                 const oldValue = change.changes[key].old || null;
                                 const newValue = change.changes[key].new || null;

                                 if (oldValue === null || newValue === null) {
                                    return;
                                 }

                                 return `<strong>${this.$i18n.t("changeDetails_lbl" + key)}:</strong> ${
                                    this.isValidDate(oldValue) ? this.$options.filters.FormatterDD_MM_YYYY_HH_mm(oldValue) : oldValue
                                 } → <span class='haschanged'>${this.isValidDate(newValue) ? this.$options.filters.FormatterDD_MM_YYYY_HH_mm(newValue) : newValue}</span><br/>`;
                              })
                              .join("\n");
                           return `<div>${segmentInfo} ${details}</div>`;
                        })
                        .join("\n\n");
                  };

                  const changesMessage = createChangesMessage(changes);

                  const addChangeFlags = (segments, changes) =>
                     segments.map((segment) => {
                        const matchingChange = changes.find((change) => change.flightIndex === segment.flightIndex && change.segmentIndex === segment.segmentIndex);
                        const updatedSegment = { ...segment };
                        Object.keys(segment).forEach((key) => {
                           updatedSegment[key] = {
                              value: segment[key],
                              hasChanged: matchingChange ? key in matchingChange.changes : false,
                           };
                        });
                        return updatedSegment;
                     });

                  const oldSegmentsWithChanges = addChangeFlags(res.oldSegments, changes);
                  const newSegmentsWithChanges = addChangeFlags(res.newSegments, changes);

                  changesMessage;
                  oldSegmentsWithChanges;
                  newSegmentsWithChanges;

                  this.items.push({
                     id: res.task.id,
                     status: this.$options.filters.ETaskSubType(res.task.subType),
                     subType: res.task.subType,
                     subStatus: res.task.subStatus,
                     flight: {
                        route: res.oldSegments[0].flightRoute,
                        cabinType: this.$options.filters.EFltCabinType(res.oldSegments[0].cabinType),
                        marketingOperating: res.oldSegments[0].marketingAirlineCode,
                        identifier: res.task.entityId,
                        type: res.task.type,
                        openingTime: this.$options.filters.FormatterDD_MM_YYYY_HH_mm(res.task.openedDatetime),
                        updatedDatetime: this.$options.filters.FormatterDD_MM_YYYY_HH_mm(res.task.updatedDatetime),
                     },
                     newSegments: newSegmentsWithChanges,
                     oldSegments: oldSegmentsWithChanges,
                     changes: changesMessage,
                  });
               }
            })
            .finally(() => {
               this.items.sort((a, b) => {
                  return new Date(b.flight.updatedDatetime) - new Date(a.flight.updatedDatetime);
               });
            })

            .catch((err) => {
               console.error(`Task ${taskId} yüklenirken hata oluştu:`, err);
            });
      },
   },
   watch: {
      taskIds: {
         handler: function (taskIds) {
            if (taskIds.length != 0) {
               taskIds.forEach((taskId) => {
                  this.handlerConfirmation(taskId);
               });
            }
         },
      },
   },
};
</script>

<style lang="scss" scoped>
.change-details-c {
   //background-color: var(--gray-50);
   background-color: var(--gray-0);
   min-height: 500px;
   padding: 1rem;
}
</style>
